import Chip from '@material-ui/core/Chip';
import React from 'react';
import ExecutionConstants, { TestStatus } from './ExecutionConstants';

interface Props {
    status: TestStatus;
}

function ExecutionTestStatusChip(props: Props) {
    const { status } = props;
    const color = ExecutionConstants.TestStatusColors[status];
    return <Chip
        size="small"
        variant="outlined"
        label={status}
        style={{ color, borderColor: color }}
    />
};

export default ExecutionTestStatusChip;
